import { render, staticRenderFns } from "./DesktopHeader.vue?vue&type=template&id=8e7da1d0&scoped=true&"
import script from "./DesktopHeader.vue?vue&type=script&lang=js&"
export * from "./DesktopHeader.vue?vue&type=script&lang=js&"
import style0 from "./DesktopHeader.vue?vue&type=style&index=0&id=8e7da1d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e7da1d0",
  null
  
)

export default component.exports